import {
  SectionElement,
  defineElement,
  globalOn,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/new-benefits/new-benefits.ts
var NewBenefits = class extends SectionElement {
  init() {
    return __async(this, null, function* () {
      var _a;
      if (!this.benefitSwiper.swiperInstance)
        return;
      (_a = this.querySelector(`[data-gray-bullet="${this.benefitSwiper.swiperInstance.realIndex}"]`)) == null ? void 0 : _a.setAttribute("data-gray-active", "true");
      this.benefitSwiper.swiperInstance.on("slideChange", () => {
        this.updateBullets();
      });
    });
  }
  updateBullets() {
    var _a, _b, _c;
    this.querySelectorAll("[data-gray-bullet]").forEach((bullet) => {
      bullet.removeAttribute("data-gray-active");
    });
    const activeGrayBullet = (_c = this.grayBullets) == null ? void 0 : _c.filter((elm) => elm.style.display !== "none")[(_b = (_a = this.benefitSwiper.swiperInstance) == null ? void 0 : _a.realIndex) != null ? _b : 0];
    activeGrayBullet == null ? void 0 : activeGrayBullet.setAttribute("data-gray-active", "");
  }
};
__decorateClass([
  query("[data-benefit-swiper]")
], NewBenefits.prototype, "benefitSwiper", 2);
__decorateClass([
  queryAll("[data-gray-bullet]")
], NewBenefits.prototype, "grayBullets", 2);
__decorateClass([
  globalOn("benefits:init")
], NewBenefits.prototype, "init", 1);
NewBenefits = __decorateClass([
  defineElement("new-benefits")
], NewBenefits);
export {
  NewBenefits
};
